export default "__VITE_ASSET__CZSseSIL__"